export default __webpack_public_path__ + "static/media/integrador.37efe14e.png";